import Switch from "./Switch";
import Button from "./Button";
import { useRef, useState } from "react";

interface ProductPricingTableProps {
  tableTitle: string;
  tableDesc: string;
  noShipping?: boolean;
  headers: Array<any>;
  data: Array<any>;
  summaryRow?: any;
  row: any;
  includeShipping?: boolean;
  handleIncludeShipping?: any;
  handleMargin?: any;
  handleCheckAll?: any;
}

const ProductPricingTable = ({
  tableTitle,
  tableDesc,
  noShipping,
  headers,
  data,
  summaryRow,
  row,
  includeShipping,
  handleIncludeShipping,
  handleMargin,
  handleCheckAll,
}: ProductPricingTableProps) => {
  const marginSelect = useRef<any>();
  const marginInput = useRef<any>();
  const marginType = useRef<any>();

  const [marginValue, setMarginValue] = useState<any>(0);

  const handleMarginUpdate = () => {
    if (+marginValue === 0) {
      handleMargin(marginType.current.value, marginInput.current.value);
    } else {
      handleMargin("%", marginValue);
    }
  };

  const handleMarginSelect = () => {
    setMarginValue(marginSelect.current.value);
  };

  return (
    <div className="mt-12">
      <div className="p-5 mb-6 bg-[#eeeeee] rounded-lg">
        <h3 className="mb-2">{tableTitle}</h3>
        <div>{tableDesc}</div>
      </div>

      <div className="flex max-md:flex-col items-center justify-between gap-6 mt-12 mb-6">
        <div className="flex items-center gap-1">
          {!noShipping && (
            <>
              <div className="-my-4">
                <Switch
                  onChange={() => handleIncludeShipping(!includeShipping)}
                  defaultChecked={includeShipping}
                />
              </div>{" "}
              Include Shipping Cost in profit calculation
            </>
          )}
        </div>
        <div className="flex flex-wrap items-center gap-3">
          <div className="font-bold">Set Profit Margin</div>
          <div>
            <select
              className="py-3 px-2 bg-gray-50 rounded-md border border-gray-300"
              name="margin"
              id="margin"
              defaultValue="0"
              ref={marginSelect}
              onChange={handleMarginSelect}
            >
              <option value="0">Set Profit Margin</option>
              <option value="25">25% Margin</option>
              <option value="50">50% Margin</option>
            </select>
          </div>
          {+marginValue === 0 && (
            <>
              <div>
                <input
                  className="p-2 w-12 bg-gray-50 rounded-md border border-gray-300 text-center"
                  type="text"
                  name=""
                  id=""
                  defaultValue="0"
                  ref={marginInput}
                />
              </div>
              <div>
                <select
                  className="py-2.5 px-2 bg-gray-50 rounded-md border border-gray-300"
                  name=""
                  id=""
                  defaultValue="%"
                  ref={marginType}
                >
                  <option value="%">%</option>
                  <option value="$">$</option>
                </select>
              </div>
            </>
          )}
          <Button type="primary" onClick={handleMarginUpdate}>
            UPDATE
          </Button>
        </div>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="uppercase bg-gray-50 text-left">
              <th className="p-4">
                <input
                  className="w-4 h-4"
                  type="checkbox"
                  name=""
                  id=""
                  onChange={handleCheckAll}
                />
              </th>
              {headers.map((header) => (
                <th key={header} className="px-4">
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="text-gray-900 font-bold">
            {summaryRow}
            {data.map((dataRow, index) => row(dataRow, index))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ProductPricingTable;
